import { render, staticRenderFns } from "./JobPage.vue?vue&type=template&id=535902da&scoped=true"
import script from "./JobPage.vue?vue&type=script&lang=js"
export * from "./JobPage.vue?vue&type=script&lang=js"
import style0 from "./JobPage.vue?vue&type=style&index=0&id=535902da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535902da",
  null
  
)

export default component.exports